import {ComponentStyleConfig} from '@chakra-ui/react';

export const Link: ComponentStyleConfig = {
  baseStyle: {
    // color: 'neutral.50'
  },
  variants: {
    navigation: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      px: 4,
      py: 3,
      rounded: 'md',
      borderRadius: 'lg',
      transition: 'background-color .25s ease-in-out',
      cursor: 'pointer',
      '&, :hover': {
        textDecoration: 'none'
      },
      ':hover, &.isActive': {
        background: 'primary.900'
      },
      '&.isActive': {
        color: 'primary.300'
      }
    }
  }
};
